import { render, staticRenderFns } from "./ConsultaPendenciaDetails.vue?vue&type=template&id=4be0ea82"
import script from "./ConsultaPendenciaDetails.vue?vue&type=script&lang=js"
export * from "./ConsultaPendenciaDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports